import { CountryContext, PatientContext } from "@ngt/opms";
import { FC, PropsWithChildren, useCallback, useContext, useEffect } from "react";
import { Locale, Patient } from "../../api/dtos";
import LocaleActionContext from "../../contexts/LocaleActionContext";
import LocaleContext from "../../contexts/LocaleContext";
import useSetLanguagePreferences from "../../hooks/locale/useSetLanguagePreference";

import LocalesContext from "../../contexts/LocalesContext";

interface IPatientLanguageSetterWrapperProps extends PropsWithChildren {

}
const PatientLanguageSetterWrapper: FC<IPatientLanguageSetterWrapperProps> = ({children}) => {
    const { data: untypedPatient, loading: patientLoading, refresh: refreshPatient } = useContext(PatientContext);
    const { setLocale } = useContext(LocaleActionContext);
    const { data: locale } = useContext(LocaleContext);
    const { data: locales } = useContext(LocalesContext);
    const save = useSetLanguagePreferences();

    const patient = untypedPatient as (Patient | undefined);
    
    const { data: country } = useContext(CountryContext);

    useEffect(() => {
        if(!patientLoading && !patient?.preferredLocaleId) {
            const countryName = country?.name.toLowerCase();

            let newLocaleCode = "en";

            switch(countryName) {
                case "korea": 
                    newLocaleCode = "ko";
                    break;
                default:
                    newLocaleCode = "en";
                    break;
            }

            const newLocale = locales?.find(l => l.code == newLocaleCode);
            setLocale(newLocale);
        }
        else if(!patientLoading) {
            const newLocale = locales?.find(l => l.id == patient?.preferredLocaleId);
            setLocale(newLocale);
        }

    }, [patient?.preferredLocaleId, patientLoading, locales, country]);

    
    const fn = useCallback(async (locale: Locale | undefined) => {
        await save(patient?.id, locale?.id);
        await refreshPatient();
    }, [save, refreshPatient, patient]);

    useEffect(() => {
        fn(locale);
    }, [locale]);

    return (
        <>{children}</>
    )
}

export default PatientLanguageSetterWrapper;